import { render, staticRenderFns } from "./SolutionsFormats.vue?vue&type=template&id=21d80318&scoped=true"
import script from "./SolutionsFormats.js?vue&type=script&lang=js&external"
export * from "./SolutionsFormats.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsFormats.scss?vue&type=style&index=0&id=21d80318&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d80318",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTag: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Tag/Tag.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
